import React from 'react';
import {
  Card, CardMedia, CardContent, Typography,
  IconButton, Button
} from '@mui/material';
import { EditRounded, Delete, Done, CheckCircle } from '@mui/icons-material';
import TagList from './TagList';
import { APIData } from '../../constants/APIAdresses';
import { connect } from 'react-redux';
import { ROLES } from '../../redux/permissionSlice';

const MediaItemCard = ({
  item,
  index,
  onDelete,
  onSelect,
  onDeleteTag,
  openPreviewDialog,
  openTagDialog,
  role
}) => {
  return (
    <Card key={item.id} >
      <CardMedia
        component="img"
        height="140"
        image={`${APIData.MEDIA}${item.path}`}
        alt={item.filename}
        onClick={() => openPreviewDialog(item, index)}
        style={{ cursor: 'pointer' }}
      />
      <CardContent style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <Typography
          variant="subtitle2"
          sx={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            lineHeight: '1.2',
            maxHeight: '2.4em',
            minHeight: '2.4em',
          }}
        >
          {item.filename}
        </Typography>

        <div style={{ display: "flex", gap: 5, justifyContent: "center", alignItems: "center" }}>
          <div style={{ flex: 5, maxWidth: "90%" }}>
            <TagList
              id={item.id}
              tags={item.tags}
              fileItem={item}
              maxRows={2}
              onDeleteTag={(tag, idx) => onDeleteTag(index, tag, idx)}
            />
          </div>

          <div style={{
            flex: 1,
            maxWidth: 30,
            justifyContent: "flex-end",
            display: "flex",
            alignItems: "center",
          }}>
            <IconButton
              onClick={() => openTagDialog(item, index)}
              sx={{
                width: 30,
                height: 30,
                borderRadius: 10,
                bgcolor: "primary.main",
                "&:hover": {
                  bgcolor: "primary.dark",
                },
              }}
            >
              <EditRounded style={{ fontSize: "18px", color: "#F8F8F8" }} />
            </IconButton>
          </div>
        </div>
        {role === ROLES.ADMIN &&
          <Button onClick={onDelete} color='error' size='small' variant='outlined' startIcon={<Delete />} style={{ marginTop: 10 }}>
            Löschen
          </Button>
        }
      </CardContent>
      {onSelect &&
        <div onClick={() => { onSelect(item) }} style={{ height: 40, width: "100%", backgroundColor: '#1976d2', display: "flex", justifyContent: "center", alignItems: "center", gap: 5, cursor: "pointer" }}>
          <CheckCircle style={{ color: '#ffffff', }} />
          <Typography variant="caption" style={{ color: '#fff', fontWeight: 'bolder' }}>Auswählen</Typography>
        </div>
      }
    </Card>
  );
};
function mapStateToProps(state) {
  return {
    role: state.permission.role
  }
}
export default connect(mapStateToProps, null)(MediaItemCard);
